import React from 'react';

import CustomInput from '../../../components/Inputs/CustomInput/CustomInput';
import { FieldContainer } from './styles';
import { UserInfoProps } from './types';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import { generateChangePasswordLink } from '../../../../services/auth/changePassword';

const UserInfo: React.FC<UserInfoProps> = ({
  userName,
  setUserName,
  email,
  setEmail,
  password,
  setPassword,
  handleOnDisplayNameSave,
}) => {
  const { t } = useI18n();

  const handleUserNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value.trim().length === 0 || value.length > 50) {
      return;
    }

    setUserName(value);
  };

  const handlePasswordLink = () => {
    window.location.href = generateChangePasswordLink();
  };

  const handleSaveClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleUserNameChange(e);
    handleOnDisplayNameSave(e.target.value);
  };

  return (
    <FieldContainer>
      <CustomInput
        label={t(TranslationKeys.userSettings_label_userName)}
        value={userName}
        onChange={handleUserNameChange}
        isEditInput={true}
        readonly={false}
        onSave={handleSaveClick}
      />
      <CustomInput
        label={t(TranslationKeys.userSettings_label_email)}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        isEditInput={true}
        readonly={true}
      />
      <CustomInput
        label={t(TranslationKeys.userSettings_label_password)}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        isEditInput={true}
        editByExternalLink={true}
        handleLinkTo={handlePasswordLink}
      />
    </FieldContainer>
  );
};

export default UserInfo;
